import React, { useEffect, useRef, useState } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

import { Redirect } from "react-router";
import useRoutes from "../../../hooks/useRoutes";
import AppBar from "../../Components/AppBar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CheckoutProvider, {
  useCheckout,
} from "../../../providers/CheckoutProvider";
import SelectDeliveryOption from "../../../Components/Checkout/SelectDeliveryOption";
import SelectPaymentOption from "../../../Components/Checkout/SelectPaymentOption";
import OrderContent from "../../../Components/Checkout/OrderContent";
import VerifyAndFinishCard from "./Components/VerifyAndFinishCard";
import UpsaleWizard from "../../../Components/Checkout/UpsaleWizard";
import { Trans } from "react-i18next";
import { serverOrderLinesToServerProductOrderLines } from "../../../providers/ShoppingCartProvider";

const CheckoutWrapper = () => {
  return (
    <CheckoutProvider>
      <Checkout />
    </CheckoutProvider>
  );
};

export default CheckoutWrapper;

const Checkout = () => {
  const { isLoaded, cart, transaction, hasActiveRebateCampaigns } =
    useCheckout();
  const routes = useRoutes();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isInitialized = useRef(false);
  const [headerQuantity, setHeaderQuantity] = useState(0);
  const [headerTotalPrice, setHeaderTotalPrice] = useState(0);

  useEffect(() => {
    if (!isLoaded || isInitialized.current) {
      return;
    }

    // Track views on first load only
    if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
      const items = serverOrderLinesToServerProductOrderLines(cart.orderLines);
      window.epmsAnalytics.onBeginCheckout(items);
    }

    // Keep the free-shipping message at the amount from the start of
    // checkout. Adding postage can take the total over the threshold, but
    // should not trigger a rebate.
    const totalPrice = cart.summary.totalPrice || 0;
    console.log("Total price from cart", totalPrice, cart);
    setHeaderTotalPrice(totalPrice);

    isInitialized.current = true;
  }, [isLoaded]);

  useEffect(() => {
    if (!isLoaded || !cart) {
      return;
    }

    // Product additions, including catalogue upsells, should be reflected in
    // the cart badge. Delivery and payment lines have other types and remain
    // excluded from the quantity.
    const quantity = cart.orderLines
      .filter((ol) => ol.type == 0)
      .reduce((total, ol) => total + ol.quantity, 0);
    setHeaderQuantity(quantity);
  }, [isLoaded, cart]);

  useEffect(() => {
    if (transaction && transaction.uuid) {
      document.location.href = `/m/shopping-cart/checkout/payment/${transaction.uuid}`;
    }
  }, [transaction]);

  if (isLoaded && cart.orderLines.filter((ol) => ol.type == 0).length == 0) {
    return <Redirect to={routes.products} />;
  }

  return (
    <MobilePage>
      <AppBar
        overrideQuantity={headerQuantity}
        overrideTotalPrice={headerTotalPrice}
      />
      <PageHeader>
        <Trans>Finish order</Trans>
      </PageHeader>
      <Container disableGutters={isMobile} maxWidth={"sm"}>
        <Box mb={2}>
          <SelectDeliveryOption />
        </Box>
        <Box mb={2}>
          <SelectPaymentOption />
        </Box>
        <Box mb={2}>
          <VerifyAndFinishCard>
            {cart && (
              <OrderContent
                orderLines={cart.orderLines}
                hasActiveRebateCampaigns={hasActiveRebateCampaigns}
                rebateCode={cart.rebateCode}
              />
            )}
          </VerifyAndFinishCard>
        </Box>
      </Container>
      <UpsaleWizard />
    </MobilePage>
  );
};
